import useToastContext from "hooks/useToastContext";
import { AiFillEdit } from "react-icons/ai";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/pathObj";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";

const SkillList = ({ skillList, allSkill, page, handleEdit, sort, setSort }) => {
  const notification = useToastContext();
  const { t } = useTranslation();

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.skillStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allSkill();
      }
    } catch (error) {
      console.log("error in get all city list==>>>>", error.message);
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="text-left text-[#A5A5A5] w-full text-xs dark:text-gray-400 ">
            <thead className="text-gray-900 border border-[#E1E6EE] text-xs bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3 ">
                  Sr no.
                </th>
                <th className="px-6 py-3 " scope="col">
                  {t("DEPARTMENT")}
                </th>

                <th scope="col" className="py-3 px-6">
                  {t("SKILLS")}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => {
                    if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                      setSort({
                        sortType: "desc",
                        sortBy: "createdAt",
                      });
                    } else {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortType === "asc" && sort.sortBy === "createdAt" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 rotate-180 h-4 " />}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 cursor-pointer py-3 "
                  onClick={() => {
                    if (sort.sortBy === "updatedAt" && sort.sortType === "asc") {
                      setSort({
                        sortBy: "updatedAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortType: "asc",
                        sortBy: "updatedAt",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("UPDATED_DATE")}</span>
                    <span>
                      {sort.sortType === "asc" && sort.sortBy === "updatedAt" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortType === "desc" && sort.sortBy === "updatedAt" && <BsArrowUpShort className="h-4 rotate-180 w-4 " />}
                    </span>
                  </div>
                </th>
                <th className="py-3 px-6 text-center" scope="col">
                  {t("O_STATUS")}
                </th>
                <th scope="col" className="px-6 text-center py-3 ">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {skillList &&
                skillList.map((item, i) => {
                  return (
                    <tr key={i} className="dark:border-gray-700 bg-white border-b dark:bg-gray-800 ">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="border-r py-4 px-6 text-gray-900">{item?.Department?.name}</td>
                      <td className="py-4 border-r px-6 text-gray-900">{item?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900 text-left">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="px-6 border-r py-4 text-gray-900 text-left">{dayjs(item?.updatedAt).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="text-center py-4 px-6 border-r text-gray-900 ">
                        <label className="items-center inline-flex relative cursor-pointer" title={`${item?.status === "active" ? "Active" : "Inactive"}`}>
                          <input
                            type="checkbox"
                            onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
                            className="sr-only peer"
                            checked={item?.status === "active"}
                          />
                          <div className="after:bg-white after:border-gray-300 w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                        </label>
                      </td>
                      <td className="text-gray-900 py-4 px-6 border-l ">
                        <div className="">
                          <ul className="flex justify-center">
                            <li className="hover:bg-white px-2 py-2 hover:text-LightBlue" onClick={() => handleEdit(item)}>
                              <a className="duration-150 hover:text-blue-700 transition ease-in-out" title="Edit" data-bs-toggle="tooltip">
                                {" "}
                                <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(skillList) ? (
                <tr className="text-center bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="border-r py-4 px-6 " colSpan={7}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SkillList;
